import React, { useEffect, useState } from 'react';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

type FileIconProps = {
  alt: string;
  className: string;
  file: appStorageRecords.AppStorageFile;
};

const FileIcon: React.FC<FileIconProps> = ({
  alt,
  className,
  file,
}) => {
  const iconUrl = file.getIconUrl();
  const [imageSrc, setImageSrc] = useState(iconUrl);

  // Reset image src if the passed file changes. Since these views / components are being recycled,
  // the image can be stale from a previous list render / state if not updated.
  useEffect(() => {
    setImageSrc(iconUrl);
  }, [iconUrl]);

  return (
    <img
      alt={alt}
      className={className}
      data-ot-ignore
      onError={() => setImageSrc(file.getFallbackIconUrl())}
      src={imageSrc}
    />
  );
};

export default FileIcon;
